import { useContextState } from "../../../../../../hooks/theme";

export const useStyles = () => {
  const { colors: color } = useContextState()
  return {
    tab2: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    },
    container: {
      position: 'relative',
      padding: '50px 50px 50px 2px',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '& .table-container': {
        // maxHeight: 'calc(100vh - 300px)',
        // height: 'calc(100vh - 300px)',
      },
      '& .MuiTableCell-root.MuiTableCell-root .MuiBox-root': {
        justifyContent: 'start',
        '& .MuiFormControlLabel-root': {
          marginLeft: '0px',
        },
      },
    },
    delete: {
      /* position: "relative",
      bottom: '-15px',
      left: '-5px', */
      fontSize: '14px',
      /* '& .MuiSvgIcon-root': {
        fontSize: '1.2rem',
      }, */
      color: 'white',
      marginRight: '10px',
      '&.MuiButtonBase-root':{
        backgroundColor: color.color31,
        /* transition: 'all 0.3s ease', */
        '&:hover': { 
          fontSize: '13px',
          transform: 'scale(0.99)', 
        },
      }
    },
    userAmount: {
      fontSize: '35px',
      fontWeight: '500'
    },
    questionnaireAccess: {
      fontSize: '14px',
      fontWeight: '500'
    },
    header: {
      '&.MuiTableCell-head': {
        minWidth: '100px',
      },
      '&.MuiTableCell-root.MuiTableCell-root': {
        vertialAlign: 'middle',
      },
    },
    flex: {
      display: 'flex',
      alignItems: 'center'
    },
    containerButton:{
      display:'flex',
      alignItems: 'center',
      gap: 2
    },
    containerTabList: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      marginTop: 3
    },
    tabContext: {
      padding: '0px 2px'
    },
    tabList: {
      position: 'relative',
      bottom: '-10px',
      borderBottom: 'none',
      '& .MuiTabs-indicator': {
        height: '0px'
      },
      '& .MuiTabs-flexContainer': {
        justifyContent: 'end',
        gap: 1,
        padding: '1px 2px 0px',
        '& .Mui-selected': {
          color: color.primary,
          background: color.color5,
          '-webkit-box-shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
          '-moz-box-shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
          'box- shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
        }
      }
    },
    headerSecondTab: {
      display: 'flex', 
      width: '100%', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom:'20px'
    },
    containerLoader: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    label: {
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      '& .MuiTypography-root': {
        fontSize: '12px',
        fontWeight: '500',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '12px',
        fontWeight: '400',
        color: color.color5,
      }
    },
  }
}
